import classNames from 'classnames';
import React from 'react';

import {AvatarShape, AvatarSize} from 'ui-library/avatar/AvatarConstants';

interface AvatarIconProps {
  alt?: string;
  avatarUrl: string;
  className?: string;
  size: AvatarSize;
  shape?: AvatarShape;
}

/**
 * An avatar icon based on a user's avatar image.
 */
export default function AvatarIcon({
  alt,
  avatarUrl,
  className,
  size,
  shape = AvatarShape.CIRCLE,
}: AvatarIconProps): JSX.Element {
  return (
    <img
      {...(alt != null ? {alt} : {})}
      className={classNames('avatar', `avatar--${size}`, `avatar--${shape}`, className)}
      src={avatarUrl}
    />
  );
}
